export default __webpack_public_path__ + "static/media/positive.e2bb659f.svg";